import React, { Fragment, useState, useEffect } from 'react';
import "../styles/pagination.css";
import { Link } from 'react-router-dom';
import Pagination from './../../../components/Pagination';
import Services, { URI } from '../../../services/service';
import { useHistory } from 'react-router-dom'
import UserService from '../../../services/UserService';
import ReactPaginate from "react-paginate";
import { useSelector } from 'react-redux';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import swal from 'sweetalert';
import { Container, Row, Col, Tab, Nav, Button, Card, Modal, OverlayTrigger, Tooltip, TabPane } from 'react-bootstrap';
import { colors } from "../../../components/common/element/elements.js";
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import cookies from 'js-cookie';
import CryptoJS from "crypto-js";
import { COURSE_URL, USER_API } from '../../../services/service';
import { Rating } from 'react-simple-star-rating';
import { Circles } from 'react-loader-spinner';
import { FaStar } from "react-icons/fa";
import '../components/courseItemGrid.css';
import moment from 'moment';


const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },

    //{
    //     code: 'hi',
    //     name: 'Hindi',
    //     country_code: 'in'
    // },
    // {
    //     code: 'pu',
    //     name: 'Punjabi',
    //     country_code: 'in'
    // },
    // {
    //     code: 'te',
    //     name: 'Telugu',
    //     country_code: 'in'
    // },
    // {
    //     code : 'mr',
    //     name : 'Marathi',
    //     country_code : 'in'
    // }
]


const UserEnrolledCoursesGrid = (props) => {

    let RESTRICTED = "Restricted";
    let currentCourseState;

    useEffect(() => {
        UserService.generateToken();
    }, []);

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()
    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])

    const um_api = URI.SERVER?._USER_API;


    const [loading, setLoading] = useState(false);
    const [rating, setRating] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [getAvgRating, setAvgRating] = useState([]);
    const [postsPerPage] = useState(10);
    const [courseState, setCourseState] = useState([]);
    const [filteredCourse, setFilteredCourse] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [paidJsonState, setPaidJsonState] = useState();
    const [freeJsonState, setFreeJsonState] = useState();
    const [hovered, setHovered] = useState(false);
    const history = useHistory();
    let paidStat = useSelector(state => state.paidCourse);
    let freeStat = useSelector(state => state.freeCourse);
    let searchEngine = useSelector(state => state.searchEngine);
    let categoryValue = useSelector(state => state.categoryValue);
    let dummyCategory = [];
    if (categoryValue) {
        dummyCategory = courseState.filter(function (ele) {
            return ele.courseDetails.category == categoryValue;
        })

    }
    // useEffect(() => {
    //     Services.getCourseDetails()
    //         .then(res => {
    //             
    //             setCourseState(res.data)
    //         })
    //         .catch(err => {
    //            
    //         })
    // }, [])
    // var userId = UserService.getUserid();
    let value = useSelector(state => state.inputValue);
    let userId = UserService.getUserid();
    let roleId = 1;
    useEffect(() => {
        const fetchPosts = async () => {
            setLoading(true);
            const res = await Services.getUserEnrolledCourses(userId, roleId);
            setCourseState(res.data);

            setPaidJsonState(res.data.filter(function (ele) {
                if (ele.courseDetails.courseFee > 0)
                    return ele.courseDetails.courseFee > 0;
            }));
            setFreeJsonState(res.data.filter(function (ele) {
                return ele.courseDetails.courseFee == 0;
            }));
            setLoading(false);
        };
        fetchPosts();
    }, []);

    useEffect(() => {
        ratingTest();

    }, [courseState])

    // useEffect(() => { console.log("getAvgRating", getAvgRating) }, [getAvgRating])
    const ratingTest = () => {

        courseState.map((data, i) => {
            ////console.log(data.courseId);

            setRating(rating => [...rating, { itemId: data.id.courseId, reviewType: 1, tenantId: 1 }])
        })
    }

    useEffect(() => {
        ////console.log("108" + rating);
        // if (rating !== " ") {
        Services.averageRating(rating)
            .then(res => {
                setAvgRating(res.data);
            })
        // }
    }, [rating]);



    const [searchEngineData, setsearchEngineData] = useState([]);
    const [getCourseIdsData, setCourseIdsData] = useState([]);
    let courseIds = [];
    let tenentId = [];
    let uniqueCourseIds;
    let tenids;

    if (value) {
        let data = courseState.filter((course) =>
            course.courseDetails.courseName.toLowerCase().includes(value)
        )
        currentCourseState = data.slice(0, 1000);
    }
    else if (categoryValue) {
        currentCourseState = dummyCategory.slice(0, 1000);
    }
    else if (paidStat) {
        if (paidJsonState == undefined) {
            currentCourseState = courseState.slice(0, 1000);
        } else {
            currentCourseState = paidJsonState.slice(0, 1000);
        }
    }
    else if (freeStat) {
        if (freeJsonState == undefined) {
            currentCourseState = courseState.slice(0, 1000);
        } else {
            currentCourseState = freeJsonState.slice(0, 1000);
        }
    }
    else if (searchEngine) {
        currentCourseState = getCourseIdsData.slice(0, 1000);
    }
    else {
        currentCourseState = courseState.slice(0, 1000);
    }
    // const currentCourseState = courseState.slice(indexOfFirstPost, indexOfLastPost);

    // Change page
    const paginate = pageNumber => setCurrentPage(pageNumber);
    useEffect(() => {
        console.log("couse state ============= ?", currentCourseState)
    }, [courseState])
    const usersPerPage = 9;
    const pagesVisited = pageNumber * usersPerPage;

    const pageCount = Math.ceil(currentCourseState.length / usersPerPage);

    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };

    const cipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(32)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return text => text.split('')
            .map(textToChars)
            .map(applySaltToChar)
            .map(byteHex)
            .join('');
    }

    const handleContentDependOnDate = (closingDate) => {

        const dateLimit = moment(closingDate);
        const now = moment();

        if (dateLimit.isValid() && dateLimit > now) {

            return true
        }
    };

    const CourseDetails = (id, tid, status) => {

        const secretKey = "cdac@123"

        const encodedCourseId = CryptoJS.AES.encrypt(
            `${id}`,
            secretKey
        ).toString();
        const safeEncodedCourseId = encodedCourseId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        const encodedTenantId = CryptoJS.AES.encrypt(
            `${tid}`,
            secretKey
        ).toString();
        const safeEncodedTenantId = encodedTenantId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        history.push(`${process.env.PUBLIC_URL + "/course-details/"}${safeEncodedCourseId}/${safeEncodedTenantId}/${status}`);
    }

    const fee_validator = (fees, courseType, foreignFees) => {

        if (courseType === "free") {
            return "Free Course"
        }
        else if (courseType === "paid") {
            return <div>&#8377;{fees} {foreignFees > 0 && <span> / &#0036;{foreignFees}</span>}</div>
        }
        else {
            return <div>{RESTRICTED}</div>
        }
    }

    if (loading) {
        return <div
            style={{
                position: 'fixed', // Ensures the div stays on top of other content
                top: 0,
                left: 0,
                width: '100vw', // Covers the entire viewport width
                height: '100vh', // Covers the entire viewport height
                backgroundColor: 'rgba(255, 255, 255, 0.562)', // Semi-transparent background
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center', // Centers the loading indicator vertically
                alignItems: 'center', // Centers the loading indicator horizontally
                zIndex: 999, // Ensures the div is on top of other elements
            }}
        >
            <Circles
                height={40}
                width={40}
                color="#4fa94d"
                ariaLabel="circles-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
        </div>;
    }

    const imageUrls = (url) => {
        if (url == null) {
            return '';
        } else {
            let imagepath = url.replace(/\\/g, "\\\\");
            let imageurl = `${URI.SERVER?._COURSE_URL}/${imagepath}`;
            return imageurl;
        }

    }

    const toggleHover = () => {
        setHovered(true);
    }

    const toggleHover1 = () => {
        setHovered(false);
    }

    return (
        <>
            {currentCourseState.length == 0 ? <div style={{ marginLeft: '30px' }}>{t('user_not_enrolled')} <br></br>{t('pls_go_to_course')} -{'>'} {t('view_course_details_remark')}</div> :

                <Fragment>
                    {/* Course Item */}

                    {currentCourseState.slice(pagesVisited, pagesVisited + usersPerPage).map((data, i) => (

                        <Col lg="4" md="12" key={i} >
                            <div className="course-card">
                                <Link onClick={() => CourseDetails(data.id.courseId, 1, data.courseDetails.status)}>
                                    <div className="course-image-cd">
                                        <img onMouseOver={toggleHover} onMouseOut={toggleHover1} style={{ backgroundImage: `url(${imageUrls(data.courseDetails.imageUrl)})` }} />
                                        <span className="badge">Fully Self-Paced Learning</span>
                                        {data.userCourseProgressDTO.certDownloadStatus == "GENERATED"? <OverlayTrigger overlay={<Tooltip>Certificate Available</Tooltip>}><span className="certificate-badge"><i class="las la-certificate la-3x"></i></span></OverlayTrigger>:<></>}
                                    </div>
                                </Link>
                                <div className="course-content-cs">
                                    <h3 className="course-title">{data.courseDetails.courseName}</h3>

                                    <div className="course-meta">
                                        <div className="duration" ><i class="fa fa-clock-o" aria-hidden="true"></i>  {data.courseDetails.duration} Days</div>

                                        <div className="rating">
                                            <ul className="list-unstyled list-inline">
                                                {(() => {
                                                    const matchedRating = getAvgRating.find(
                                                        (d) => data.courseDetails.courseId?.toString() === d.itemId
                                                    );

                                                    if (matchedRating && matchedRating.avgScore > 0) {
                                                        // Matching rating found → yellow star
                                                        return (
                                                            <li className="rating-item">
                                                                <FaStar color="#FFD700" size={16} style={{ marginRight: "4px" }} />
                                                                {matchedRating.avgScore}
                                                            </li>
                                                        );
                                                    } else {
                                                        // No rating found → gray star
                                                        return (
                                                            <li className="rating-item">
                                                                <FaStar color="#c7c7c7ff" size={16} style={{ marginRight: "4px" }} />
                                                                0
                                                            </li>
                                                        );
                                                    }
                                                })()}
                                            </ul>

                                        </div>
                                        {/* {data.courseDetails.courseType == "free" ? <><i class='fas fa-money-check'></i>Free </> : <><div className="fees"><i class='fas fa-money-check'></i> ₹{data.courseDetails.courseFee} <br /> ${data.courseDetails.courseForeignFees}</div></>} */}
                                        {<OverlayTrigger overlay={<Tooltip>Course Progress</Tooltip>}><div className="progress-course"><i class='fas fa-tasks'></i> {data?.userCourseProgressDTO.progress} %</div></OverlayTrigger>}
                                    </div>

                                </div>
                                <div className="course-footer">
                                    {data.courseDetails.status == "P"?handleContentDependOnDate(data.courseEndDate) ? 
                                    <button className="enroll-btn-new" onClick={() => CourseDetails(data.id.courseId, 1, data.courseDetails.status)} >Active Course</button> 
                                    : <button className="enroll-btn-closed" onClick={() => CourseDetails(data.id.courseId, 1, data.courseDetails.status)}>Course Closed</button>
                                    :data.courseDetails.status == "D"?
                                    <><button className="enroll-btn-closed" onClick={() => CourseDetails(data.id.courseId, 1, data.courseDetails.status)}>Course Disabled</button></>
                                    : <><button className="enroll-btn-closed" onClick={() => CourseDetails(data.id.courseId, 1, data.courseDetails.status)}>Course Closed</button></>}
                                </div>
                            </div>
                        </Col>
                    ))
                    }
                </Fragment >
            }
            {
                currentCourseState.length == 0 ? null :
                    <Col md="12" className="text-center">
                        <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                        />
                    </Col>
            }

        </>
    )
}

export default UserEnrolledCoursesGrid;